"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
});

var _utils = require("@material-ui/core/utils");


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/utils/createSvgIcon.js
// module id = 3
// module chunks = 0